
import React from 'react';

import { TabPanel } from '../../core';
import SharePanel from './SharePanel';

const renderTabPanel = (props) => {
    return (
        <TabPanel key={props.name} name={props.name} iconName={props.iconName} title={props.title}>
            <SharePanel />
        </TabPanel>
    );
}

export default renderTabPanel;
